<template>
  <div class="loading-bounce">
    <div class="child-bounce loading-bounce-1"></div>
    <div class="child-bounce loading-bounce-2"></div>
    <div class="child-bounce loading-bounce-3"></div>
  </div>
</template>

<script>
  export default {
    name: 'loading-bounce',
  };
</script>



// WEBPACK FOOTER //
// LoadingBounce.vue?667601cc